module.exports = __webpack_public_path__ + "static/sylwiawork1-4659ea27326d9f7f6dc436a450bd1ab1.jpg";